import { SetUnSavedChangeModalAction, UnSavedChangeModalType } from '../interface';
import { SHOW_UNSAVEDCHANGEMODAL } from '../types';

export default function setEditableModal(unSavedChangeModal: UnSavedChangeModalType): SetUnSavedChangeModalAction {
  return {
    type: SHOW_UNSAVEDCHANGEMODAL,
    unSavedChangeModal
  };
}
